import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { userProvider } from '../../data/providers/userProvider';
import { IPermission, IUser } from '../../data/types';
import { AccessDenied } from './AccessDenied';

interface IMatchParams {
  teamId: string;
}

interface IProps extends RouteComponentProps<IMatchParams> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
}

const TeamAccessCheckComponent: React.FunctionComponent<IProps> = (
  props: IProps
): React.ReactElement => {
  const [authChecked, setAuthChecked] = React.useState<boolean>(false);
  const [initialCheck, setInitialCheck] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect((): (() => void) => {
    const subscriber = userProvider().subscribe((user: IUser): void => {
      setInitialCheck(true);
      setAuthChecked(true);

      if (!isEmpty(user)) {
        setLoading(false);
      }
    });
    return (): void => {
      subscriber.unsubscribe();
    };
  }, [props.match.params.teamId]);

  return authChecked ? (
    props.children
  ) : !initialCheck && loading ? null : (
    <AccessDenied />
  );
};

const TeamAccessCheck = withRouter(TeamAccessCheckComponent);

export { TeamAccessCheck };

const isOrgAdmin = (user: IUser): boolean => {
  return (
    !isEmpty(user) && !isEmpty(user.claims) && user.claims.orgAdmin === true
  );
};

const hasTeamAccess = (user: IUser, teamId: string): boolean => {
  if (!isEmpty(user) && !isEmpty(user.permissions)) {
    const team = user.permissions.find(
      (p: IPermission): boolean => p.id === teamId
    );
    return !!team;
  }
  return false;
};
